import { render, staticRenderFns } from "./IndustrialMapPage.vue?vue&type=template&id=513607d9&scoped=true"
import script from "./IndustrialMapPage.vue?vue&type=script&lang=js"
export * from "./IndustrialMapPage.vue?vue&type=script&lang=js"
import style0 from "./IndustrialMapPage.vue?vue&type=style&index=0&id=513607d9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513607d9",
  null
  
)

export default component.exports